import { useMemo } from 'react';
import { HomeOutlineInterfaceSVG, RefreshInterfaceSVG } from '@sbercloud/uikit-product-icons';
import { useLocale } from '@sbercloud/uikit-product-locale';
import { isBrowser } from '@snack-uikit/utils';
import { ErrorType } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function useGetContentByErrorType(errorType) {
  var _useLocale = useLocale('ErrorPage'),
    t = _useLocale.t;
  return useMemo(function () {
    switch (errorType) {
      case ErrorType.PageUnavailable:
        return {
          title: t('pageUnavailableTitle'),
          text: t('actionRedirectTitle'),
          statusCode: 403
        };
      case ErrorType.PageNotFound:
        return {
          title: t('pageNotFoundTitle'),
          text: t('actionRedirectTitle'),
          statusCode: 404
        };
      case ErrorType.Offline:
        return {
          title: t('offlineTitle'),
          text: t('offlineText')
        };
      case ErrorType.Redirect:
        return {
          title: t('redirectTitle'),
          text: t('redirectText')
        };
      case ErrorType.FrontendError:
      default:
        return {
          title: t('frontendErrorTitle'),
          text: t('actionRedirectTitle')
        };
    }
  }, [errorType, t]);
}
export function useGetButtonPropsByErrorType(errorType, mainPageUrl) {
  var _useLocale2 = useLocale('ErrorPage'),
    t = _useLocale2.t;
  return useMemo(function () {
    switch (errorType) {
      case ErrorType.PageNotFound:
      case ErrorType.PageUnavailable:
        return {
          text: t('mainPageLink'),
          icon: /*#__PURE__*/_jsx(HomeOutlineInterfaceSVG, {}),
          href: mainPageUrl
        };
      case ErrorType.Redirect:
        return {
          text: t('redirectButton'),
          href: mainPageUrl
        };
      default:
        return {
          text: t('refreshButton'),
          icon: /*#__PURE__*/_jsx(RefreshInterfaceSVG, {}),
          onClick: function onClick() {
            return isBrowser() && window.location.reload();
          }
        };
    }
  }, [errorType, mainPageUrl, t]);
}